import React, { useState } from "react"
import { Modal, ModalBody } from "reactstrap"
import All from "./All/All"
import Search from "../../../../../components/common/Search/Search"

const SelectProductsModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)

  const tabs = ["All", "Recommended", "Top Trending", "New"]
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "50%",
          maxWidth: "80%",
        }}
      >
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mt-3">Select Products</h5>
            <Search placeholder="Search" />
          </div>

          <div className="d-flex my-3 gap-3">
            {tabs.map((tab) => (
              <div
                className="fw-medium"
                style={{
                  color: tab === activeTab ? "#EC7426" : "black",
                  cursor: "pointer",
                  transition: "color 1s ease",
                  fontSize: "1.25rem",
                  padding: ".5rem 0rem",
                }}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>

          {activeTab === "All" && <All />}

          <div className="d-flex justify-content-end mt-3">
            <div className="d-flex gap-2 fw-medium">
              <div className="border border-dark rounded rounded-3 px-2 py-1 cursor-pointer" onClick={toggle}>
                Cancel
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default SelectProductsModal
